/**
 * 隐秘处方划价模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 新增隐秘处方划价单 --- 馆内、电子处方
export const comboPaymentAdd1 = (params) => {
  return req.post('/payment/combo', params);
}

// 新增隐秘处方划价单 手写、补录 --- 馆内、手写处方
export const comboPaymentAdd2 = (params) => {
  return req.post('/payment/combo/handwritten', params);
}

// 新增隐秘处方划价单 自建收费、微信拍单 --- 馆内/馆外、手写处方
export const comboPaymentAdd3 = (params, uuid, code) => {
  return req.post(`/payment/combo/insert?uuid=${uuid}&code=${code}`, params);
}

// 修改隐秘划价单
export const comboPaymentEdit = (params) => {
  return req.put('/payment/combo', params);
}

// 隐秘划价单付款
export const comboPaymentPay = (params) => {
  return req.post(`/payment/combo/payment`, params);
}

// 多条隐秘处方划价单付款
export const paymentAllCombo = (list) => {
  return req.post('/payment/combo/payments', list);
}

// 查询隐秘处方划价单收费记录
export const comboPaymentRecord = (recipeComboId) => {
  return req.get(`/payment/combo/getCharge/${recipeComboId}`);
}

// 根据隐秘处方划价单id删除隐秘处方划价单
// export const comboPaymentDelete = (paymentRecipeComboIds) => {
//   return req.delete(`/payment/combo/${paymentRecipeComboIds}`);
// }
export const comboPaymentDelete = (parmas) => {
  return req.delete(`/payment/combo`,parmas);
}

// 根据隐秘处方划价单id作废隐秘处方划价单
// export const comboPaymentInvalid = (paymentRecipeComboId, value) => {
//   return req.post(`/payment/combo/invalid/${paymentRecipeComboId}/${value}`);
// }
export const comboPaymentInvalid = (params) => {
  return req.post(`/payment/combo/invalid`,params);
}

// 根据隐秘处方划价单信息退款 --- 线下支付
export const comboPaymentRefund = (params) => {
  return req.post(`/payment/combo/refund`, params);
}

// 根据隐秘处方划价单id退款 --- 微信支付
export const comboPaymentRefund1 = (paymentRecipeComboId) => {
  return req.post(`/wechat/pay/paymentComboRefund/${paymentRecipeComboId}`);
}

// 查询隐秘处方划价单列表
export const comboPaymentList = (params) => {
  return req.get(`/payment/combo/list`, params);
}

// 查询隐秘处方划价单列表 --- orderId
export const comboPayments = (orderId) => {
  return req.get(`/payment/combo/list?orderId=${orderId}`);
}

// 查询隐秘处方划价单状态数量
export const statusNumCombo = (params) => {
  return req.get(`/payment/combo/statusNumber`, params);
}

// 根据隐秘处方划价单id获取隐秘处方划价单详情
export const comboPaymentDetails = (paymentRecipeComboId) => {
  return req.get(`/payment/combo/${paymentRecipeComboId}`);
}

// 根据隐秘处方拍单id获取隐秘处方划价单详情
export const comboPaymentDetailByAuctionId = (auctionId) => {
  return req.get(`/payment/combo/auction/${auctionId}`);
}

// 根据隐秘处方划价单id获取隐秘处方划价单小票信息
export const comboSmallTicket = (id) => {
  return req.get(`/payment/combo/printCharge/${id}`);
}

// 根据隐秘处方划价单id获取隐秘处方打印详情
export const combo = (paymentRecipeComboId, type) => {
  return req.get(`/payment/combo/printRecipe/${paymentRecipeComboId}/${type}`);
}

// 根据隐秘处方划价单id获取扭转单数据
export const reverseCombo = (paymentRecipeComboId) => {
  return req.get(`/payment/combo/printOrder/${paymentRecipeComboId}`);
}

// 根据隐秘处方划价单id获取同城快递单数据
export const deliveryComboTC = (paymentRecipeComboId) => {
  return req.get(`/payment/combo/printDelivery/${paymentRecipeComboId}`);
}

// 根据隐秘处方划价单id获取顺丰快递单数据
export const deliveryComboSF = (paymentRecipeComboId) => {
  return req.get(`/sfexpress/order/getOrderPrint/${paymentRecipeComboId}/2`);
}

// 修改隐秘处方划价单物流信息
export const deliveryComboEdit = (params) => {
  return req.put(`/payment/combo/updateOrderByDelivery`, params);
}